import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineDot from "@mui/lab/TimelineDot";
import LooksOneRoundedIcon from "@mui/icons-material/LooksOneRounded";
import LooksTwoRoundedIcon from "@mui/icons-material/LooksTwoRounded";
import Looks3RoundedIcon from "@mui/icons-material/Looks3Rounded";
import LaunchIcon from "@mui/icons-material/Launch";

import "./experience-page.css";

import { Chip } from "@mui/material";

function ExperiencePage() {
  return (
    <div id="experience">
      <div className="global-title" data-aos="fade-up">
        Experience
      </div>
      <div className="global-subtitle" data-aos="fade-up">
        Software Engineer Experience Timeline
      </div>
      <Timeline position="left" className="timeline">
        <TimelineItem>
          <TimelineOppositeContent
            sx={{ m: "auto 0" }}
            variant="body2"
            color="text.secondary"
          >
            <div className="timeline-content-op" data-aos="fade-left">
              11/01/2024 - 26/09/2024 · 9 mos{" "}
              <div>
                <strong>
                  <u>Projects Worked on</u>
                </strong>
              </div>
              <div>• EL-Core Company Website (Tech Lead).</div>
              <div>• Janashakthi Digital Website (Tech Lead)</div>
              <div>• vKYC - Video Know Your Customer (SE)</div>
              <div>• Janashakthi Group Life (SE)</div>
            </div>
          </TimelineOppositeContent>
          <TimelineSeparator data-aos="fade-up">
            <TimelineConnector />
            <TimelineDot sx={{ bgcolor: "black" }}>
              <Looks3RoundedIcon />
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent data-aos="fade-right" sx={{ py: "12px", px: 2 }}>
            <div className="timeline-content">
              <div className="timeline-title">
                <img
                  className="timeline-image"
                  src="https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013144/echonlabs_logo_ekbsc4.webp"
                  alt="EL"
                />{" "}
                &nbsp;
                <a
                  className="company-link"
                  href="http://www.echonlabs.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Echonlabs (PVT) LTD <LaunchIcon fontSize="small" />
                </a>
              </div>
              <div className="timeline-subtitle">
                Associate Software Engineer
              </div>
              <div className="timeline-chips">
                <Chip
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  color="primary"
                  size="small"
                  label="Angular"
                />
                &nbsp;
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="Express/JS"
                />
                &nbsp;
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="Node/JS"
                />
                &nbsp;
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="MongoDB"
                />
              </div>
            </div>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem>
          <TimelineOppositeContent
            sx={{ m: "auto 0" }}
            variant="body2"
            color="text.secondary"
          >
            <div className="timeline-content-op" data-aos="fade-left">
              10/07/2023 - 09/01/2024 · 6 mos{" "}
            </div>
          </TimelineOppositeContent>
          <TimelineSeparator data-aos="fade-up">
            <TimelineConnector />
            <TimelineDot sx={{ bgcolor: "black" }}>
              <LooksTwoRoundedIcon />
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent data-aos="fade-right" sx={{ py: "12px", px: 2 }}>
            <div className="timeline-content">
              <div className="timeline-title">
                <img
                  className="timeline-image"
                  src="https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013144/echonlabs_logo_ekbsc4.webp"
                  alt="EL"
                />{" "}
                &nbsp;
                <a
                  className="company-link"
                  href="http://www.echonlabs.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Echonlabs (PVT) LTD <LaunchIcon fontSize="small" />
                </a>
              </div>
              <div className="timeline-subtitle">Trainee Software Engineer</div>
              <div className="timeline-chips">
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="Angular"
                />
                &nbsp;
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="Express/JS"
                />
                &nbsp;
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="Node/JS"
                />
                &nbsp;
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="MongoDB"
                />
              </div>
            </div>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem className="gap">
          <TimelineOppositeContent
            sx={{ m: "auto 0" }}
            align="right"
            variant="body2"
            color="text.secondary"
          >
            <div className="timeline-content-op" data-aos="fade-left">
              2020 - 2023 BCS Degree · 3 yrs{" "}
            </div>
          </TimelineOppositeContent>
          <TimelineSeparator data-aos="fade-up">
            <TimelineConnector />
            <TimelineDot sx={{ bgcolor: "black" }}>
              <strong>Gap</strong>
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent
            data-aos="fade-right"
            sx={{ py: "12px", px: 2 }}
          ></TimelineContent>
        </TimelineItem>

        <TimelineItem>
          <TimelineOppositeContent
            sx={{ m: "auto 0" }}
            align="right"
            variant="body2"
            color="text.secondary"
          >
            <div className="timeline-content-op" data-aos="fade-left">
              01/12/2019 - 25/07/2020 · 8 mos{" "}
              <div>
                <strong>South Asian Unit</strong>
              </div>
            </div>
          </TimelineOppositeContent>
          <TimelineSeparator data-aos="fade-up">
            <TimelineConnector />
            <TimelineDot sx={{ bgcolor: "black" }}>
              <LooksOneRoundedIcon />
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent data-aos="fade-right" sx={{ py: "12px", px: 2 }}>
            <div className="timeline-content">
              <div className="timeline-title">
                <img
                  className="timeline-image"
                  src="https://res.cloudinary.com/ddjpxsrej/image/upload/v1728013153/ifs_logo_tubcul.webp"
                  alt="IFS"
                />{" "}
                &nbsp;
                <a
                  className="company-link"
                  href="https://www.ifs.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  IFS International <LaunchIcon fontSize="small" />
                </a>
              </div>
              <div className="timeline-subtitle">Trainee Software Engineer</div>
              <div className="timeline-chips">
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="C#"
                />
                &nbsp;
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label=".NET"
                />
                &nbsp;
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="PL/SQL"
                />
                &nbsp;
                <Chip
                  color="primary"
                  style={{ backgroundColor: "var(--purple_c)", color: "black" }}
                  size="small"
                  label="MySQL"
                />
              </div>
            </div>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </div>
  );
}

export default ExperiencePage;
